/**
* 快捷版mix----猜你喜欢模块
* 1，点击sku跳转用openByKpl()方法
* 2, class类命名时最好前面加上当前模块的名字，以防跟其他类冲突
*/
<template>
    <div class='clearfix font-pin bg-grey-dark h-full'>
        <div class="p-2 flex-col flex-wrap h-full">
            <div class="mb-2 mt-3 text-40 font-600 font-pin ml-4">猜你喜欢</div>
            <div
                class="flex items-center webkit-box"
                v-if="recommendList.length > 0"
            >
                <div class="flex-col w-1-2 h-full mx-1 round-16">
                    <div
                        class="flex-col w-full mt-2 round-16"
                        v-for="(item, i) in jilist"
                    >
                        <div
                            class="w-full round-16"
                            :id="i"
                            @click="jumpSku(item)"
                            :clstag="'jr|keycount|8530052_1227_index_like|'+item.clstags||item.itemDetail.skuId"
                            v-if="item.type === '101'"
                        >
                            <div class="flex-col bg-white w-full round-16">
                                <!--                        <div class="bg-cover bg-center bg-no-repeat w-336 h-336" :style="{'background-color': 'url(../assets/guide3.png)'}"></div>-->
                                <img
                                    :src="item.itemDetail.image_url"
                                    class="w-full round-t-16 min-h-450"
                                    :style="{backgroundColor: item.itemDetail.color}"
                                />
                                <div class="w-full flex-col pb-4_1 px-3 py-1">
                                    <span
                                        class="round-4 HomeNewWhatDoYouLike-title -mt-3 text-brown line-ms text-24 font-500 w-125 h-40 line-40 text-center text-middle"
                                        v-if="item.itemDetail.installment !== 0"
                                    >{{item.itemDetail.installment}}期免息</span>
                                    <span class="inline-block text-overflow line-clamp-2 mt-2">
                                        <span
                                            class="bg-red text-white text-20 px-1 line-sm round-4 mr-1 text-center text-middle"
                                            v-if="item.itemDetail.selfService === 1"
                                        >自营</span>
                                        <span class="text-26 font-400 line-md font-pin">{{item.itemDetail.ad_title}}</span>
                                    </span>
                                    <span class="text-26 text-red pt-2 pb-1">
                                        <span class="font-udc font-700">￥</span>
                                        <span class="text-36 font-700 font-udc">{{item.itemDetail.installmentPrice}}</span>
                                        <span
                                            class="text-grey-darken text-24 font-400 pl-1"
                                            v-if="item.itemDetail.installment !== 0"
                                        >每期</span>
                                    </span>
                                    <div
                                        class="flex items-center pt-1 pb-2"
                                        v-if="item.itemDetail.installment !== 0"
                                    >
                                        <span class="border-orange-dark bg-white round-4 text-orange-dark text-20 line-32 h-32 px-1 text-center text-middle">白条</span>
                                        <!--                                        <span class="border-orange-dark bg-white round-4 text-orange-dark text-20 line-sm h-32 px-1 ml-1_1">信用卡</span>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="round-8 w-full round-16 mx-1 pt-3"
                            :id="i"
                            @click="navigatorTo(item)"
                            :clstag="'jr|8530052_1227_index_like|'+ item.itemDetail.id"
                            v-else
                        >
                            <div
                                class="bg-cover bg-cover bg-no-repeat w-full round-t-16 min-h-350"
                                :style="{backgroundImage: 'url('+item.itemDetail.middleImg+')', backgroundColor: item.itemDetail.color}"
                            >
                                <span
                                    class="round-t-r-l text-28 px-2 bg-red text-white font-600 line-md absolute -mt-3"
                                    v-if="item.itemDetail.customLabel !==''"
                                >{{item.itemDetail.customLabel}}</span>
                            </div>
                            <div class="p-3 flex-col bg-white w-full round-16">
                                <span class="text-28 font-600 line-md font-pin text-overflow line-clamp-2">{{item.itemDetail.title}}</span>
                                <div class="flex items-center justify-between py-2">
                                    <div class="flex items-center">
                                        <img
                                            class="w-50 h-50 round-full"
                                            :src="item.itemDetail.userImg"
                                        />
                                        <span class="text-grey-darken text-22 ml-1_1 text-overflow line-clamp-1">{{item.itemDetail.authorNicker}}</span>
                                    </div>
                                    <div class="flex items-center">
                                        <img
                                            src="../../public/images/zan.svg"
                                            class="w-40 h-40"
                                        />
                                        <span class="text-grey-darken text-22 font-700 ml-1">{{item.itemDetail.favorCount === 0 ? '': item.itemDetail.favorCount}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex-col w-1-2 h-full mx-1 round-16">
                    <div
                        class="flex-col w-full mt-2 round-16"
                        v-for="(item,i) in oulist"
                    >
                        <div
                            class="w-full round-16"
                            :id="i"
                            @click="jumpSku(item)"
                            :clstag="'jr|keycount|8530052_1227_index_like|'+item.clstags|| item.itemDetail.skuId"
                            v-if="item.type === '101'"
                        >
                            <div class="flex-col bg-white w-full round-16">
                                <!--                        <div class="bg-cover bg-center bg-no-repeat w-336 h-336" :style="{'background-color': 'url(../assets/guide3.png)'}"></div>-->
                                <img
                                    :src="item.itemDetail.image_url"
                                    class="w-full round-t-16 min-h-350"
                                    :style="{backgroundColor:  item.itemDetail.color}"
                                />
                                <div class="w-full flex-col pb-4_1 px-3 py-1">
                                    <span
                                        class="round-4 HomeNewWhatDoYouLike-title -mt-3 text-brown line-ms text-24 font-500 w-125 h-40 line-40 text-center"
                                        v-if="item.itemDetail.installment !== 0"
                                    >{{item.itemDetail.installment}}期免息</span>
                                    <span class="inline-block text-overflow line-clamp-2 mt-2">
                                        <span
                                            class="bg-red text-white text-20 px-1 line-sm round-4 mr-1"
                                            v-if="item.itemDetail.selfService === 1"
                                        >自营</span>
                                        <span class="text-26 font-400 line-md">{{item.itemDetail.ad_title}}</span>
                                    </span>
                                    <span class="text-26 text-red pt-2 pb-1">
                                        <span class="font-udc font-700">￥</span>
                                        <span class="text-36 font-700 font-udc">{{item.itemDetail.installmentPrice}}</span>
                                        <span
                                            class="text-grey-darken text-24 font-400 pl-1"
                                            v-if="item.itemDetail.installment !== 0"
                                        >每期</span>
                                    </span>
                                    <div
                                        class="flex items-center pt-1 pb-2"
                                        v-if="item.itemDetail.installment !== 0"
                                    >
                                        <span class="border-orange-dark bg-white round-4 text-orange-dark text-20 line-32 h-32 px-1">白条</span>
                                        <!--                                        <span class="border-orange-dark bg-white round-4 text-orange-dark text-20 line-sm h-32 px-1 ml-1_1">信用卡</span>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="round-8 w-full round-16 mx-1 pt-3"
                            :id="i"
                            @click="navigatorTo(item)"
                            :clstag="'jr|8530052_1227_index_like|'+ item.itemDetail.id"
                            v-else
                        >
                            <div
                                class="bg-cover bg-cover bg-no-repeat w-full round-t-16 min-h-350"
                                :style="{backgroundImage: 'url('+item.itemDetail.middleImg+')',backgroundColor: item.itemDetail.color}"
                            >
                                <span
                                    class="round-t-r-l text-28 px-2 bg-red text-white font-600 line-md absolute -mt-3"
                                    v-if="item.itemDetail.customLabel !==''"
                                >{{item.itemDetail.customLabel}}</span>
                            </div>
                            <div class="p-3 flex-col bg-white w-full round-16">
                                <span class="text-28 font-600 line-md text-overflow line-clamp-2">{{item.itemDetail.title}}</span>
                                <div class="flex items-center justify-between py-2">
                                    <div class="flex items-center">
                                        <img
                                            class="w-50 h-50 round-full"
                                            :src="item.itemDetail.userImg"
                                        />
                                        <span class="text-grey-darken text-22 ml-1_1 text-overflow line-clamp-1">{{item.itemDetail.authorNicker}}</span>
                                    </div>
                                    <div class="flex items-center">
                                        <img
                                            src="../../public/images/zan.svg"
                                            class="w-40 h-40"
                                        />
                                        <span class="text-grey-darken text-22 font-700 ml-1">{{item.itemDetail.favorCount === 0 ? '': item.itemDetail.favorCount}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="flex items-center justify-center py-4 text-grey-darken w-full text-26"
                v-show="more"
            >{{moreText}}
            </div>
        </div>
    </div>
</template>
<script>
// height:450
import { openByKpl } from '../util/kpl';
import { PostSever } from '@/util/sqRequestService';
import request from '@/util/request';
import { getQuery } from '@/util/url';

let domain = `${location.protocol}//ms.jr.jd.com`;
let mixflag = false;
switch (process.env.VUE_APP_ENV) {
    // case 'dev':
    case 'minner':
        domain = `${location.protocol}//msinner.jr.jd.com`;
        // domain = 'https://ms.jr.jd.com';
        break;
    case 'dev':
        domain = location.origin;
        // domain = 'https://ms.jr.jd.com';
        break;
    default:
        break;
}
export default {
    name: 'HomeNewWhatDoYouLike',
    components: {},
    data() {
        return {
            recommendId: 125,
            deviceId: 0,
            lastId: 0,
            pageNo: 1,
            pageSize: 10,
            end: 1,
            recommendList: [],
            jilist: [],
            oulist: [],
            moreText: '上拉加载更多...',
            more: false
        };
    },
    created() {
        // 添加滑动监听事件
        // window.addEventListener('scroll', this.pageScroll);
        if (document.getElementsByClassName('cls-msg-page') && document.getElementsByClassName('cls-msg-page').length) {
            document.getElementsByClassName('cls-msg-page')[0].addEventListener('scroll', this.pageScroll, true);
        } else {
            window.addEventListener('scroll', this.pageScroll, true);
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        onTouchStart(e) {
            // this.startY = e.targetTouches[0].pageY;
        },
        onTouchMove(e) {
            // if (e.targetTouches[0].pageY - this.startY < 50) {
            //     this.pageScroll();
            // }
        },
        pageScroll() {
            // 上滑加载更多
            // e.preventDefault()
            let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
            if (this.end === 0) {
                this.more = true;
                this.moreText = '上拉加载更多...';
                let cheight = document.documentElement.clientHeight;
                let dheight = document.documentElement.scrollHeight;
                if (dheight <= scrollHeight + cheight + 100 && !mixflag && this.more) {
                    mixflag = true;
                    let timer = setTimeout(() => {
                        clearTimeout(timer);
                        mixflag = false;
                    }, 500);
                    // this.more = true;
                    this.pageNo += 1;
                    this.getData();
                }
            } else {
                this.more = false;
                this.moreText = '没有更多了';
            }
        },
        getData() {
            // 获取feed流数据
            let me = this;
            let qs = getQuery();
            me.coverSku = qs.sku || '';
            //添加内外联动
            if ($.device.jdjr && qs.skuId && qs.from == 'jdjr') {
                me.coverSku = qs.skuId;
                delete qs.sku;
                delete qs.otherSku;
            }
            if ($.device.jdjr && qs.otherSku && qs.from == 'jdjr') {
                me.coverSku = qs.otherSku;
                delete qs.skuId;
                delete qs.sku;
            }
            let jda = '';
            if (!!document.cookie) {
                document.cookie.split(';').forEach(data => {
                    if (data.includes('_jda')) {
                        jda = data.split('=')[1];
                    }
                });
            }
            this.device_id = $.device_id;
            this.lastId = this.lastId === 0 ? '0' : this.lastId;
            let time = new Date().toLocaleDateString().replace(/\//g, '');
            let reqData = JSON.stringify({
                recommendId: this.recommendId,
                deviceId: this.deviceId,
                ip: '117.136.79.92',
                source: 'h5',
                jda: jda,
                lastId: this.lastId,
                rid: time + Math.round(Math.random() * 10000),
                pageNO: this.pageNo,
                pageSize: this.pageSize,
                coverSku: me.coverSku > 0 ? me.coverSku : ''
                // coverSku: '100003730605'
            });
            // let req = new URLSearchParams({reqData: reqData}).toString();
            PostSever(`${domain}/gw/generic/base/h5/m/recommendGetWay`, { reqData: reqData }).then(res => {
                let { resultData, isEnd } = res.resultData;
                this.end = isEnd;
                if (resultData && resultData.length > 0) {
                    resultData.forEach((item, i) => {
                        if (item.itemDetail && item.itemDetail.middleImg) {
                            if (item.itemDetail.middleImg && item.itemDetail.middleImg.includes(',')) {
                                item.itemDetail.middleImg = item.itemDetail.middleImg.split(',')[0];
                            }
                        }
                        if ((i + 1) % 2 === 0) {
                            this.oulist.push(item);
                        } else {
                            this.jilist.push(item);
                        }
                        item.itemDetail.color = this.colorRandom();
                        return item;
                    });
                    this.recommendList = this.recommendList.concat(resultData);
                    // this.jilist = this.recommendList.filter((item, i) => (i + 1) % 2 === 1)
                    // this.oulist = this.recommendList.filter((item, i) => (i + 1) % 2 === 0)
                    let lastdetail = resultData[resultData.length - 1];
                    this.lastId = lastdetail.type === '100' ? lastdetail.itemDetail.id : lastdetail.itemDetail.skuId;
                }
            });
        },
        //颜色对象
        colorRandom() {
            let r = Math.floor(Math.random() * 255);
            let g = Math.floor(Math.random() * 255);
            let b = Math.floor(Math.random() * 255);
            return 'rgba(' + r + ',' + g + ',' + b + ',0.3)';
        },
        // getImg(resultData) {
        //   // 获取图片原始宽高
        //   return new Promise(resolve => {
        //     resultData.map(o => {
        //       let img = new Image();
        //       img.src = o.itemDetail.image_url || o.itemDetail.middleImg.split(',')[0];
        //       if(o.itemDetail.middleImg) {
        //         o.itemDetail.middleImg = o.itemDetail.middleImg.split(',')[0] || o.itemDetail.middleImg;
        //       }
        //       if(img.naturalHeight) {
        //         console.log('sad'+img.naturalHeight)
        //         if(img.naturalHeight > 225)
        //         {
        //           img.naturalHeight = 200 / 16;
        //         }
        //         else if (img.naturalHeight < 80)
        //         {
        //           img.naturalHeight = 150 / 16;
        //         }
        //         else
        //         {
        //           img.naturalHeight = img.naturalHeight / 16;
        //         }
        //         o.width = img.naturalWidth;
        //         o.height = img.naturalHeight;
        //       } else {
        //         img.onload = () => {
        //           if(img.height > 225)
        //           {
        //             img.height = 200 / 16;
        //           }
        //           else if (img.height < 80)
        //           {
        //             img.height = 150 / 16;
        //           }
        //           else
        //           {
        //             img.height = img.height / 16;
        //           }
        //           o.width = img.width;
        //           o.height = img.height;
        //         }
        //       }
        //       return o;
        //     });
        //     resolve(resultData)
        //   })
        // },
        //跳转文章
        navigatorTo(item) {
            let url = '';
            if (item && item.itemDetail) {
                url = item.itemDetail.clickURL || item.itemDetail.simpleContentUrl;
                if (url) {
                    // 添加锚点
                    if ($.device && $.device.jdjr && window.JrBridge) {
                        window.JrBridge.openView({
                            target: url,
                            container: 'h5',
                            islogin: true,
                            isclose: false
                        });
                    } else {
                        location.href = url;
                    }
                }
            }
        },
        //跳转sku
        jumpSku(item) {
            if (item && item.itemDetail && item.itemDetail.click_url) {
                openByKpl({
                    url: item.itemDetail.click_url,
                    sku: item.itemDetail.skuId,
                    eventId: 'MInterestFree_DailySelected',
                    eventParam: ''
                });
            }
        }
    },
    beforeDestroy() {
        // 销毁前删除滚动监听事件
        if (document.getElementsByClassName('cls-msg-page') && document.getElementsByClassName('cls-msg-page').length) {
            document.getElementsByClassName('cls-msg-page')[0].removeEventListener('scroll', this.pageScroll, true);
        } else {
            window.removeEventListener('scroll', this.pageScroll, true);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../scss/utils';

.HomeNewWhatDoYouLike-bg-top-gradient {
    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(247, 247, 247, 1) 100%);
}

.HomeNewWhatDoYouLike-title {
    background: linear-gradient(270deg, rgba(247, 224, 166, 1) 0%, rgba(239, 195, 136, 1) 100%);
}

.webkit-box {
    display: -webkit-box;
    -webkit-box-pack: center;
    -webkit-box-orient: horizontal;
}
</style>